import { Box, Flex, Text, VStack } from "@chakra-ui/react";
import { CornerDownRight } from "lucide-react";
import { useMainChatContext } from "@root/context/kps-chat-context";
import { useTranslation } from "react-i18next";
import { CHAT_COLORS } from "@root/components/chat/chatStyles";

const ChatFollowUpQuestions = ({
  followUpQuestions = [],
  onSubmitHandler,
}: any) => {
  const { submitHandler } = useMainChatContext();
  const { t } = useTranslation("common");

  const handleClick = (question: string) => {
    if (!question) return;
    // Use the provided onSubmitHandler if available, otherwise use the context submitHandler
    if (onSubmitHandler) {
      onSubmitHandler(question);
    } else {
      submitHandler(question, true);
    }
  };

  return (
    <Box mt="4px" w="100%">
      <Text fontSize="12px" fontWeight="600" color={CHAT_COLORS.muted} mb="8px">
        {t("translate.followUps")}
      </Text>
      <VStack align="stretch" spacing="6px">
        {followUpQuestions?.map((q: any, idx: number) => (
          <Flex
            key={`${idx}-${q}`}
            as="button"
            type="button"
            align="center"
            gap="10px"
            textAlign="left"
            px="14px"
            py="10px"
            bg="white"
            border={`1px solid ${CHAT_COLORS.border}`}
            borderRadius="10px"
            color={CHAT_COLORS.muted}
            transition="all 0.15s"
            _hover={{ borderColor: CHAT_COLORS.brand, bg: CHAT_COLORS.hoverBg, color: CHAT_COLORS.brand }}
            onClick={() => handleClick(q)}
          >
            <CornerDownRight size={15} style={{ flexShrink: 0 }} />
            <Text fontSize="14px" color={CHAT_COLORS.body} lineHeight="1.45">
              {q}
            </Text>
          </Flex>
        ))}
      </VStack>
    </Box>
  );
};

export default ChatFollowUpQuestions;
